/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Edit_Title_SaveInputs */

const cs_chat_edit_title_save = /** @type {(inputs: Chat_Edit_Title_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit název`)
};

const en_chat_edit_title_save = /** @type {(inputs: Chat_Edit_Title_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save name`)
};

/**
* | output |
* | --- |
* | "Save name" |
*
* @param {Chat_Edit_Title_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_edit_title_save = /** @type {((inputs?: Chat_Edit_Title_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Edit_Title_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_edit_title_save(inputs)
	return cs_chat_edit_title_save(inputs)
});